<script setup>

const form = useFormData();
const step = useStep();
const { t, setLocale } = useI18n()


const possibleCountries = [
    { text: t('states.germany'), value: "de" },
    { text: t('states.austria'), value: "at" },
    { text: t('states.switzerland'), value: "ch" },
    { text: t('states.france'), value: "fr" },
    { text: t('states.estonia'), value: "ee" },
    { text: t('states.sweden'), value: "se" },
    { text: t('states.italy'), value: "it" },
    { text: t('states.united_kingdom'), value: "gb" },
    { text: t('states.ireland'), value: "ie" },
    { text: t('states.usa'), value: "us" },
    { text: t('states.netherlands'), value: "nl" },
    { text: t('states.spain'), value: "es" },
    { text: t('states.portugal'), value: "pt" },
    { text: t('states.czech_republic'), value: "cz" },
    { text: t('states.slovakia'), value: "sk" },
    { text: t('states.hungary'), value: "hu" },
    { text: t('states.poland'), value: "pl" },
    { text: t('states.croatia'), value: "hr" },
    { text: t('states.bosnia_and_herzegovina'), value: "ba" },
    { text: t('states.slovenia'), value: "si" },
    { text: t('states.lithuania'), value: "lt" },
    { text: t('states.latvia'), value: "lv" },
    { text: t('states.finland'), value: "fi" },
    { text: t('states.denmark'), value: "dk" },
    { text: t('states.norway'), value: "no" },
    { text: t('states.bulgaria'), value: "bg" },
    { text: t('states.belgium'), value: "be" },
    { text: t('states.greece'), value: "el" },
    { text: t('states.luxembourg'), value: "lb" },
    { text: t('states.romania'), value: "ro" },
    { text: t('states.serbia'), value: "rs" },
    { text: t('states.turkey'), value: "tr" },
    { text: t('states.north_macedonia'), value: "mk" },
];


let responseData = ref();
let isUpdating = ref(false);
let isNoWarranty = ref(false);
let isToastVisible = ref(false);
let errorToastMessage = ref("")

const isButtonEnabled = computed(() => {
    return form.value.productNumber && form.value.address.countryIso;
});

async function incStep() {
    if (step.value.currentStep < step.value.maxSteps) {
        const success = await submit();
        if (success) {
            // switch (form.value.countryIso) {
            //     case "en":
            //         setLocale("en-US");
            //     case "fr":
            //         setLocale("fr-FR");
            //     default:
            //         setLocale("de-DE");
            // }
            step.value.currentStep++;
        }
    }
}

async function submit() {
    try {
        isUpdating.value = true;
        isNoWarranty.value = false;

        const response = await fetch(`/api/getWarrentyExtensionForProduct?productNumber=${form.value.productNumber}&countryIso=${form.value.address.countryIso}`);
        responseData = await response.json();

        if (responseData === null, !response.ok) {
            // error
            errorToastMessage.value = responseData.message;
            if (response.status === 404) {
                errorToastMessage.value = t('product_not_found_error') + " service@scheppach.com.";
            }
            isToastVisible.value = true;
            return false;
        } else if (responseData.warrantyExtensionYears <= 0) {
            // no warranty
            isNoWarranty.value = true;
            console.log("No warranty left for this product");
            return false;
        } else {
            // has warranty
            form.value.productName = responseData.productName;
            form.value.maxRegistrationDays = responseData.maxRegistrationDays;
            // console.log("Warranty details:", responseData);
            return true;
        }
    } catch (error) {
        // error
        console.log("catch error")
        console.error("Error fetching warranty info:", error);
        errorToastMessage.value = t('undefined_error') + " service@scheppach.com.";
        isToastVisible.value = true;
        return false;
    } finally {
        isUpdating.value = false;
    }
}
</script>

<template>
    <SToast v-model:isVisible="isToastVisible" bgColor="#fee2e2" textColor="#dc2626" :text="errorToastMessage"
        :duration="6000" closeable />

    <!-- <SCard> -->
    <template v-if="isUpdating">
        <h2>{{ $t('loading') }}...</h2>
    </template>
    <template v-else-if="isNoWarranty">
        <div class="bg-blue-100 text-blue-800 text-center p-4 rounded-lg">
            <p class="font-semibold">{{ $t('no_warranty_for_product', { Produktbezeichnung: `${responseData.productName} (${responseData.productNumber})` }) }}</p>
        </div>
    </template>
    <template v-else>
        <section class="mb-8 h-full">
            <h3 class="text-xl font-semibold mb-3" style="color: #005188;">{{ $t("product_registration") }}</h3>
            <form @submit.prevent="submitForm" class="space-y-4">
                <!-- Artikelnummer -->
                <SNumberInput :label="$t('product_number')" v-model="form.productNumber" required />

                <SDropdown v-model="form.address.countryIso" :options="possibleCountries" :label="$t('state')"
                    :placeholder="$t('please_select')" required />

            </form>

            <div class="mt-8">
                <div class="flex flex-row justify-end">
                    <SButton @click="incStep" :disabled="!isButtonEnabled || isUpdating">
                        <SMdiIcon>arrow_forward</SMdiIcon>
                    </SButton>
                </div>
            </div>
        </section>
    </template>
    <!-- </SCard> -->
</template>

<style>
.lo {
    color: #dc2626
}
</style>
